import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { AppGlobalsService } from '../app-globals.service';
import { LU_ContactType_ext } from '../models/lu_contacttype';

@Component({
  selector: 'app-create-contact-wizard-wrapper',
  templateUrl: './create-contact-wizard-wrapper.component.html'
})
export class CreateContactWizardWrapperComponent implements OnInit {

  darkMode: boolean; glassMode: boolean;

  @Input() contactTypes: LU_ContactType_ext[] = [];

  @Output() wizardCompletedEmitter = new EventEmitter<any>();
  @Output() wizardSoftCompletionEmitter = new EventEmitter<any>();
  @Output() wizardCancelledEmitter = new EventEmitter<any>();

  constructor(private appGlobals: AppGlobalsService) { }

  ngOnInit() {
    this.darkMode = this.appGlobals.getStoredDarkModeSetting();
    this.glassMode = this.appGlobals.getStoredGlassModeSetting();
  }

}
